import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import LessonForm from '../../components/Lesson/LessonForm';
import { createLesson, getLessons } from '../../services/lessonService';
import Breadcrumb from '../../components/Breadcrumb';
import { getAuthoringAssistantCreateState } from '../../components/AI/authoringAssistantNavigation';

const LessonCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId } = useParams<{ courseId: string }>();
  const [nextOrder, setNextOrder] = useState(1);
  const assistantCreateState = getAuthoringAssistantCreateState(location.state, 'lesson');

  useEffect(() => {
    const fetchMaxOrder = async () => {
      if (courseId) {
        try {
          const response = await getLessons(parseInt(courseId, 10));
          const lessons = response.data;
          if (lessons.length > 0) {
            const maxOrder = Math.max(...lessons.map((l: any) => l.order || 0));
            setNextOrder(maxOrder + 1);
          }
        } catch (error) {
          console.error('Failed to fetch lessons:', error);
        }
      }
    };
    fetchMaxOrder();
  }, [courseId]);

  const handleCreate = async (data: { title: string; description: string; order: number; isActive: boolean }) => {
    if (courseId) {
      await createLesson(parseInt(courseId, 10), data);
      navigate(`/course/${courseId}`);
    }
  };

  return (
    <div>
      {/* Breadcrumb Navigation */}
      {courseId && <Breadcrumb courseId={courseId} additionalCrumb="New Lesson *" />}

      <h1>Luo oppitunti</h1>
      <LessonForm
        courseId={courseId ? parseInt(courseId, 10) : undefined}
        onSubmit={handleCreate}
        suggestedOrder={nextOrder}
        assistantInitialPrompt={assistantCreateState.prompt}
        assistantAutoGenerate={assistantCreateState.autoGenerate}
      />
    </div>
  );
};

export default LessonCreatePage;
